import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LANGS } from "@/i18n/translations";
import { useLang } from "@/context/LanguageContext";

export const LanguageSelector = () => {
  const { lang, setLang } = useLang();
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-selector-trigger"
          className="flex items-center gap-2 rounded-full border border-white/15 px-3.5 py-2 text-sm font-semibold text-[#FAFAFA] hover:border-[#E85D04]/50 hover:text-[#FF8C42] transition-colors"
          aria-label="Language selector"
        >
          <Globe className="h-4 w-4" />
          <span>{current.label}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="glass border-white/10 text-[#FAFAFA] min-w-[9rem]"
      >
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className="cursor-pointer focus:bg-white/10 focus:text-[#FF8C42] flex items-center justify-between"
          >
            <span>{l.name}</span>
            {lang === l.code && <Check className="h-4 w-4 text-[#E85D04]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
